import { NodeWithIsPreview, SmartEditableArea } from "@/util/SmartEditableArea";

export function Page(props: NodeWithIsPreview<Wif.Mgnl.Page>): JSX.Element | null {
  return (
    <SmartEditableArea isPreview={props.isPreview} slotNode={props.main} />
  );
}
